import { render, staticRenderFns } from "./FootLogo.vue?vue&type=template&id=58ca8cf3"
import script from "./FootLogo.vue?vue&type=script&lang=js"
export * from "./FootLogo.vue?vue&type=script&lang=js"
import style0 from "./FootLogo.vue?vue&type=style&index=0&id=58ca8cf3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports